import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tooltip from 'rc-tooltip'

const PLACEMENTS = ['left', 'right', 'top', 'bottom', 'topLeft', 'topRight', 'bottomLeft', 'bottomRight']
const TRIGGERS = ['hover', 'click', 'focus']
const BORDER_STYLES = ['dotted', 'dashed', 'solid', 'none']
const WHITE_SPACE = ['normal', 'nowrap', 'pre', 'pre-wrap', 'pre-line', 'break-spaces']
const WORD_BREAK = ['normal', 'break-all', 'keep-all', 'break-word']

const color = PropTypes.color

const theme = {
  tooltipStyles: PropTypes.shape({
    color: color,
    backgroundColor: color,
    borderWidth: PropTypes.string,
    borderColor: color,
    borderStyle: PropTypes.oneOf(BORDER_STYLES),
    borderRadius: PropTypes.string,
    margin: PropTypes.string,
    padding: PropTypes.string,
    boxShadow: PropTypes.string,
    maxWidth: PropTypes.string,
    whiteSpace: PropTypes.oneOf(WHITE_SPACE),
    wordBreak: PropTypes.oneOf(WORD_BREAK)
  })
}

class TooltipComponent extends Component {
  static propTypes = {
    tooltipText: PropTypes.string,
    placement: PropTypes.oneOf(PLACEMENTS),
    tooltipTriggerEvent: PropTypes.oneOf(TRIGGERS),
    styling: PropTypes.shape(theme),
    children: PropTypes.node
  }

  static defaultProps = {
    placement: 'bottom',
    tooltipTriggerEvent: 'hover',
    styling: {
      tooltipStyles: {
        maxWidth: '350px',
        whiteSpace: 'normal',
        wordBreak: 'break-word'
      }
    }
  }

  render () {
    const {
      children,
      tooltipText,
      placement,
      tooltipTriggerEvent,
      styling: {
        tooltipStyles
      } = {}
    } = this.props

    const { maxWidth, ...restTooltipStyles } = tooltipStyles
    return (
      <div>
        <Tooltip
          overlay={<div dangerouslySetInnerHTML={{ __html: tooltipText || 'Tooltip' }} />}
          placement={placement || 'bottom'}
          trigger={tooltipTriggerEvent || 'hover'}
          overlayStyle={{
            maxWidth
          }}
          overlayInnerStyle={{
            ...restTooltipStyles
          }}
        >
          <div>
            {children}
          </div>
        </Tooltip>
        <style jsx>{`
          :global(.rc-tooltip) {
            z-index: 2450;
          }
        `}</style>
      </div>
    )
  }
}

export default TooltipComponent
